export default "__VITE_ASSET__If$FVt1w__"